import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';

import {
    fetchPianoTechAppointmentList,
    RETURN_TO_PIANOTECHAPPOINTMENT_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHAPPOINTMENT_MODIFIED,
    SAVE_PIANOTECHAPPOINTMENT_STARTED,
    savePianoTechAppointment,
    PIANOTECHAPPOINTMENT_VALIDATE,
} from '../../actions/PianoTechAppointmentActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechAppointment,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechAppointment: state.pianoTechAppointment,
    user: state.user,
});

class PianoTechAppointment extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechAppointment.maintenanceType === MAINTENANCE_TYPE_COMPLETE)
            this.props.dispatch(fetchPianoTechAppointmentList());

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHAPPOINTMENT_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechAppointment.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechAppointment = Object.assign({}, this.props.pianoTechAppointment.originalPianoTechAppointment);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View PianoTechAppointment",
                    pianoTechAppointment,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    editPianoTechAppointment = () => {
        const pianoTechAppointment = this.props.pianoTechAppointment.pianoTechAppointment;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechAppointment",
            pianoTechAppointment,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechAppointment.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechAppointment = this.props.pianoTechAppointment.pianoTechAppointment;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechAppointment",
                    pianoTechAppointment,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechAppointment.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechAppointment';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechAppointment';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechAppointment';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHAPPOINTMENT_STARTED,
            message,
        })

        const { pianoTechAppointment } = this.props.pianoTechAppointment;
        pianoTechAppointment.maintenanceType = this.props.pianoTechAppointment.maintenanceType;
        this.props.dispatch(savePianoTechAppointment(pianoTechAppointment));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechAppointment } = this.props.pianoTechAppointment;
        pianoTechAppointment[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHAPPOINTMENT_MODIFIED,
            pianoTechAppointment,
        })

    }

    formValid = () => {
        const { pianoTechAppointment, maintenanceType } = this.props.pianoTechAppointment;
        const validFormInfo = validateForm(uiFieldInfoPianoTechAppointment, pianoTechAppointment, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechAppointment, maintenanceType } = this.props.pianoTechAppointment;
        const validInfo = validateForm(uiFieldInfoPianoTechAppointment, pianoTechAppointment, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHAPPOINTMENT_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechAppointment, originalPianoTechAppointment, maintenanceType } = this.props.pianoTechAppointment

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechAppointment, pianoTechAppointment, originalPianoTechAppointment)

    }

    render() {
        const { pianoTechAppointment } = this.props.pianoTechAppointment;

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete';

        switch (this.props.pianoTechAppointment.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.pianoTechAppointment.title} />
                <Message message={this.props.pianoTechAppointment.message}
                    type={this.props.pianoTechAppointment.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <tr>
                            <td>
                                <Button className="bluebutton" description="Return to List" onClick={this.returnToList} />
                            </td>
                            <td>
                            </td>
                        </tr>
                        {this.props.pianoTechAppointment.maintenanceType !== 'add' &&
                            <FormField row form={{ title: 'Appointment Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="appointmentId"
                                value={pianoTechAppointment.appointmentId}
                                onChange={this.onChange}
                            />
                        }
                        <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="companyId"
                            value={pianoTechAppointment.companyId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Customer Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="customerId"
                            value={pianoTechAppointment.customerId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Technicians Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="techniciansId"
                            value={pianoTechAppointment.techniciansId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Piano Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="pianoId"
                            value={pianoTechAppointment.pianoId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Tuning', type: 'checkbox', disabled }}
                            name="tuning"
                            value={pianoTechAppointment.tuning}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'ServiceReason', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="serviceReason"
                            value={pianoTechAppointment.serviceReason}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Notes', type: 'textinput', length: '1000', maxLength: '1000', disabled }}
                            name="notes"
                            value={pianoTechAppointment.notes}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'NotificationTimestamp1', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="notificationTimestamp1"
                            value={pianoTechAppointment.notificationTimestamp1}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'NotificationTimestamp2', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="notificationTimestamp2"
                            value={pianoTechAppointment.notificationTimestamp2}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'NotificationTimestamp3', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="notificationTimestamp3"
                            value={pianoTechAppointment.notificationTimestamp3}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'CustomerConfirmedTimestamp', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="customerConfirmedTimestamp"
                            value={pianoTechAppointment.customerConfirmedTimestamp}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'CustomerCancelledTimestamp', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="customerCancelledTimestamp"
                            value={pianoTechAppointment.customerCancelledTimestamp}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'AppointmentTimeStart', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="appointmentTimeStart"
                            value={pianoTechAppointment.appointmentTimeStart}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'MinutesRequired', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="minutesRequired"
                            value={pianoTechAppointment.minutesRequired}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'MinutesBefore', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="minutesBefore"
                            value={pianoTechAppointment.minutesBefore}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'MinutesAfter', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="minutesAfter"
                            value={pianoTechAppointment.minutesAfter}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'AppointmentTimeEnd', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="appointmentTimeEnd"
                            value={pianoTechAppointment.appointmentTimeEnd}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'BlockStartTime', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="blockStartTime"
                            value={pianoTechAppointment.blockStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'BlockEndTime', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="blockEndTime"
                            value={pianoTechAppointment.blockEndTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Created', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="created"
                            value={pianoTechAppointment.created}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="lastUpdated"
                            value={pianoTechAppointment.lastUpdated}
                            onChange={this.onChange}
                        />
                        <tr>
                            <td>
                                {showEdit &&
                                    <Button className="bluebutton" description="Edit" onClick={this.editPianoTechAppointment} />
                                }
                                {showDelete &&
                                    <Button className="bluebutton" description={deleteText} onClick={this.onDelete} />
                                }
                                {showSave &&
                                    <div>
                                        <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                        <Button className="bluebutton" description="Validate" onClick={this.validate} />
                                    </div>
                                }
                            </td>
                            <td>
                                <Button className="bluebutton" description={cancelCloseText} onClick={this.onCancelClose} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}

export default connect(mapStateToProps)(PianoTechAppointment);
